export default __webpack_public_path__ + "static/media/list_bullet.9b75199c.svg";